<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import ReviewEntity from "@apps/reviews/entities/ReviewEntity";
    import { ReviewTranslationResponseEntity } from "@apps/reviews/entities/ReviewTranslationEntity";
    import MinilogLogger from "@lib/Logger";
    import debounce from "debounce";
    import { scale } from "svelte/transition";

    import Masonry from "@components/Masonry/Masonry.svelte";
    import MasonryController from "@components/Masonry/MasonryController";
    import MasonryItem from "@components/Masonry/MasonryItem.svelte";

    import ReviewItemContainer from "../ReviewItemContainer.svelte";
    import ReviewsMasonryItem from "./ReviewsMasonryItem/ReviewsMasonryItem.svelte";
    import ReviewsMasonryItemSkeleton from "./ReviewsMasonryItem/ReviewsMasonryItemSkeleton.svelte";

    export let reviews: ReviewEntity[];
    export let status: STATUS;
    export let votesEnabled: boolean;
    export let showTitle: boolean;
    export let namespace: string;
    export let showProducts: boolean;
    export let reviewsTranslations: ReviewTranslationResponseEntity[] = [];
    export let translationsPendingIds: number[] = [];
    export let isIncentivizedEnabled: boolean;
    export let isReviewEditingEnabled = false;

    const logger = new MinilogLogger("masonryController");
    const masonryController = new MasonryController(logger);
    const masonrySkeletonController = new MasonryController();
    const reviewSkeletonItems = new Array(5)
        .fill(null)
        .map((_, idx) => idx + 1);

    const debouncedUpdate = debounce(
        masonryController.update.bind(masonryController),
        150
    );
    const handleImageLoaded = () => {
        debouncedUpdate();
    };
    const handleProductReady = () => {
        debouncedUpdate();
    };
    $: {
        reviews;
        masonryController.update();
    }
</script>

{#if status === STATUS.INITIAL_LOADING}
    <Masonry controller={masonrySkeletonController}>
        {#each reviewSkeletonItems as key (key)}
            <MasonryItem {key}>
                <ReviewsMasonryItemSkeleton />
            </MasonryItem>
        {/each}
    </Masonry>
{:else}
    <Masonry controller={masonryController}>
        {#each reviews as review (review.uid)}
            <MasonryItem key={review.uid}>
                <ReviewItemContainer
                    {review}
                    reviewsTranslation={reviewsTranslations.find(
                        (t) => t.reviewId === review.id
                    ) || null}
                    {translationsPendingIds}
                    {namespace}
                    on:openReview
                    on:editReview
                    let:props
                >
                    <div in:scale={{ start: 0.5, duration: 500 }}>
                        <ReviewsMasonryItem
                            {namespace}
                            {review}
                            {showTitle}
                            {showProducts}
                            {votesEnabled}
                            {isIncentivizedEnabled}
                            isReviewEditingEnabled={isReviewEditingEnabled &&
                                review.isCustomerAuthor}
                            reviewVotes={props.reviewVotes}
                            customerName={props.customerName}
                            on:openReview={props.handleOpenReview}
                            on:toggleVote={props.handleToggleVote}
                            on:editReview={props.handleEditReview}
                            on:imageLoaded={handleImageLoaded}
                            on:productReady={handleProductReady}
                        />
                    </div>
                </ReviewItemContainer>
            </MasonryItem>
        {/each}
    </Masonry>
{/if}
